import {Base,Axios} from "@/api/Base"

export class ReportDownPayrollReport extends Base {

    path = "report/downPayrollReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}